//DEV
const API_KEY_DEV = 'cyVMd3Uhck6etlnYKpgP44q7FbypYhaD7mCMrggR'
const URL_DEV = 'https://api-darkstore-dev.ripley.com.pe/admin'
// const URL_DEV = 'http://localhost:8081'
const URL_DEV_MANIFEST = 'https://api-darkstore-dev.ripley.com.pe/manifest'

//QA
const API_KEY_QA = 'm4ICqsbgZb6ssknXLUqxu9DPot8LMNVr1QsuQZjK'
const URL_QA = 'https://api-darkstore-qa.ripley.com.pe/admin'
const URL_QA_MANIFEST = 'https://api-darkstore-qa.ripley.com.pe/manifest'

//PRD
const API_KEY_PRD = 'bnKMhcwgnP9jhXGewDaO85rdppSXAJmM7fI5rdfq'
const URL_PRD = 'https://api-darkstore.ripley.com.pe/admin'
const URL_PRD_MANIFEST = 'https://api-darkstore.ripley.com.pe/manifest'

export const URLS = { URL_DEV, URL_PRD, URL_DEV_MANIFEST, URL_PRD_MANIFEST, URL_QA, URL_QA_MANIFEST }
export const API_KEYS = { API_KEY_DEV, API_KEY_PRD, API_KEY_QA }
